export default __webpack_public_path__ + "static/media/cli-pasargada.8c28e515.png";